var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 133,
    viewBox: "0 0 133 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-mail (1) 1",
    clipPath: "url(#clip0_528_7220)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M110.069 36.0557V55.0334V74.1418L80.6211 98.6826L133 132.999V55.0334L110.069 36.0557Z",
    fill: "#D8C782"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.931 55.0334V36.0557L0 55.0334V132.999L52.3791 98.6826L22.931 74.1418V55.0334Z",
    fill: "#D8C782"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M110.069 55.0334H133L110.069 36.0557V55.0334Z",
    fill: "#3E7EEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.931 36.0557L0 55.0334H22.931V36.0557Z",
    fill: "#3E7EEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M82.5517 13.7586L66.5 0L50.4482 13.7586H82.5517Z",
    fill: "#3E7EEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.931 55.0352H0V133.001H133V55.0352H110.069",
    fill: "#2D69D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M110.069 55.0352V74.1436L80.6211 98.6844L133 133.001V55.0352H110.069Z",
    fill: "#5693FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M22.931 74.1436V55.0352H0V133.001L52.3791 98.6844L22.931 74.1436Z",
    fill: "#5693FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M84.473 13.7578H22.9307V74.1421L52.3787 98.6806L59.9964 93.6885C63.9451 91.1019 69.0541 91.1019 73.0029 93.6885L80.6206 98.6806L110.069 74.1421V13.7578H84.473Z",
    fill: "#E7ECED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M80.6211 98.6844L133 133.001V55.0352L80.6211 98.6844Z",
    fill: "#3E7EEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M0 55.0352V133.001L52.3791 98.6844L0 55.0352Z",
    fill: "#3E7EEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M105.483 45.8621C118.147 45.8621 128.414 35.5955 128.414 22.931C128.414 10.2666 118.147 0 105.483 0C92.8183 0 82.5518 10.2666 82.5518 22.931C82.5518 35.5955 92.8183 45.8621 105.483 45.8621Z",
    fill: "#07B44C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M84.8448 57.3284H68.7931C67.5273 57.3284 66.5 56.3034 66.5 55.0353C66.5 53.7672 67.5273 52.7422 68.7931 52.7422H84.8448C86.1106 52.7422 87.1379 53.7672 87.1379 55.0353C87.1379 56.3034 86.1106 57.3284 84.8448 57.3284Z",
    fill: "#DD352E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M59.6208 57.3284H34.3966C33.1308 57.3284 32.1035 56.3034 32.1035 55.0353C32.1035 53.7672 33.1308 52.7422 34.3966 52.7422H59.6208C60.8866 52.7422 61.9139 53.7672 61.9139 55.0353C61.9139 56.3034 60.8866 57.3284 59.6208 57.3284Z",
    fill: "#23A24D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M91.7237 80.2581H75.672C74.4062 80.2581 73.3789 79.2331 73.3789 77.965C73.3789 76.6969 74.4062 75.6719 75.672 75.6719H91.7237C92.9895 75.6719 94.0168 76.6969 94.0168 77.965C94.0168 79.2331 92.9895 80.2581 91.7237 80.2581Z",
    fill: "#DC691D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M66.4997 80.2581H41.2755C40.0097 80.2581 38.9824 79.2331 38.9824 77.965C38.9824 76.6969 40.0097 75.6719 41.2755 75.6719H66.4997C67.7655 75.6719 68.7928 76.6969 68.7928 77.965C68.7928 79.2331 67.7655 80.2581 66.4997 80.2581Z",
    fill: "#EBBA16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M98.6039 57.3284H94.0177C92.7519 57.3284 91.7246 56.3034 91.7246 55.0353C91.7246 53.7672 92.7519 52.7422 94.0177 52.7422H98.6039C99.8697 52.7422 100.897 53.7672 100.897 55.0353C100.897 56.3034 99.8697 57.3284 98.6039 57.3284Z",
    fill: "#6B1E31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M64.2071 68.7932H48.1554C46.8896 68.7932 45.8623 67.7682 45.8623 66.5001C45.8623 65.232 46.8896 64.207 48.1554 64.207H64.2071C65.4729 64.207 66.5002 65.232 66.5002 66.5001C66.5002 67.7682 65.4729 68.7932 64.2071 68.7932Z",
    fill: "#FC3952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M98.6032 68.7932H73.379C72.1132 68.7932 71.0859 67.7682 71.0859 66.5001C71.0859 65.232 72.1132 64.207 73.379 64.207H98.6032C99.869 64.207 100.896 65.232 100.896 66.5001C100.896 67.7682 99.869 68.7932 98.6032 68.7932Z",
    fill: "#2D69D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M48.1554 45.8616H32.1037C30.8379 45.8616 29.8105 44.8366 29.8105 43.5685C29.8105 42.3004 30.8379 41.2754 32.1037 41.2754H48.1554C49.4212 41.2754 50.4485 42.3004 50.4485 43.5685C50.4485 44.8366 49.4212 45.8616 48.1554 45.8616Z",
    fill: "#EBBA16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M82.5514 45.8616H57.3273C56.0615 45.8616 55.0342 44.8366 55.0342 43.5685C55.0342 42.3004 56.0615 41.2754 57.3273 41.2754H82.5514C83.8172 41.2754 84.8445 42.3004 84.8445 43.5685C84.8445 44.8366 83.8172 45.8616 82.5514 45.8616Z",
    fill: "#DC691D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M38.9828 68.7932H34.3966C33.1308 68.7932 32.1035 67.7682 32.1035 66.5001C32.1035 65.232 33.1308 64.207 34.3966 64.207H38.9828C40.2486 64.207 41.2759 65.232 41.2759 66.5001C41.2759 67.7682 40.2486 68.7932 38.9828 68.7932Z",
    fill: "#75348B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M75.6726 34.3968H48.1554C46.8896 34.3968 45.8623 33.3717 45.8623 32.1037C45.8623 30.8356 46.8896 29.8105 48.1554 29.8105H75.6726C76.9384 29.8105 77.9658 30.8356 77.9658 32.1037C77.9658 33.3717 76.9384 34.3968 75.6726 34.3968Z",
    fill: "#2D69D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M38.9828 34.3968H34.3966C33.1308 34.3968 32.1035 33.3717 32.1035 32.1037C32.1035 30.8356 33.1308 29.8105 34.3966 29.8105H38.9828C40.2486 29.8105 41.2759 30.8356 41.2759 32.1037C41.2759 33.3717 40.2486 34.3968 38.9828 34.3968Z",
    fill: "#CB465F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M103.19 32.1042C102.582 32.1042 101.999 31.8657 101.568 31.4323L94.6891 24.553C93.7925 23.6564 93.7925 22.2072 94.6891 21.3106C95.5834 20.414 97.0372 20.414 97.9315 21.3106L103.036 26.415L112.894 14.5849C113.706 13.6103 115.15 13.4842 116.123 14.2914C117.095 15.1031 117.228 16.5478 116.416 17.5224L104.951 31.281C104.538 31.7763 103.937 32.0744 103.293 32.1019C103.258 32.1042 103.224 32.1042 103.19 32.1042Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_528_7220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 133,
    height: 133,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMail);
export default __webpack_public_path__ + "static/media/check-mail.2d521a339a8afeffe5fef0282d7a0a36.svg";
export { ForwardRef as ReactComponent };